import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import Styled from "components/finance/style";
import { view } from "@risingstack/react-easy-state";

const numberWithCommas = val => {
  const n = Number(val) || 0;
  return "$" + n.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const DEBT_COLOR = "#F5A623";
const EQUITY_COLOR = "#5C91F5";

function Chart({
  debt = 0,
  equity = 0,
  debtLabel = "Outstanding Debt",
  equityLabel = "Outstanding Equity"
}) {
  const total = (Number(debt) || 0) + (Number(equity) || 0);
  const data = [
    { name: debtLabel, value: Math.max(0, Number(debt) || 0), color: DEBT_COLOR },
    { name: equityLabel, value: Math.max(0, Number(equity) || 0), color: EQUITY_COLOR }
  ];

  const debtPct = total > 0 ? (data[0].value / total) * 100 : 0;
  const equityPct = total > 0 ? (data[1].value / total) * 100 : 0;

  return (
    <Styled.DonutWrapper>
      <Styled.DonutChart>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <Tooltip formatter={numberWithCommas} />
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius="60%"
              outerRadius="95%"
              startAngle={90}
              endAngle={-270}
              stroke="#fff"
              strokeWidth={2}
            >
              {data.map((entry, i) => (
                <Cell key={i} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <Styled.DonutCenter>
          <Styled.DonutCenterLabel>Total Capital</Styled.DonutCenterLabel>
          <Styled.DonutCenterValue>{numberWithCommas(total)}</Styled.DonutCenterValue>
        </Styled.DonutCenter>
      </Styled.DonutChart>
      <Styled.DonutLegend>
        <Styled.LegendRow>
          <Styled.LegendRowTop>
            <Styled.LegendDot color={DEBT_COLOR} />
            <Styled.LegendLabel>{debtLabel}</Styled.LegendLabel>
            <Styled.LegendValue>{numberWithCommas(data[0].value)}</Styled.LegendValue>
            <Styled.LegendPercent>{Math.round(debtPct)}%</Styled.LegendPercent>
          </Styled.LegendRowTop>
          <Styled.LegendBar>
            <Styled.LegendBarFill color={DEBT_COLOR} percentage={debtPct} />
          </Styled.LegendBar>
        </Styled.LegendRow>
        <Styled.LegendRow>
          <Styled.LegendRowTop>
            <Styled.LegendDot color={EQUITY_COLOR} />
            <Styled.LegendLabel>{equityLabel}</Styled.LegendLabel>
            <Styled.LegendValue>{numberWithCommas(data[1].value)}</Styled.LegendValue>
            <Styled.LegendPercent>{Math.round(equityPct)}%</Styled.LegendPercent>
          </Styled.LegendRowTop>
          <Styled.LegendBar>
            <Styled.LegendBarFill color={EQUITY_COLOR} percentage={equityPct} />
          </Styled.LegendBar>
        </Styled.LegendRow>
      </Styled.DonutLegend>
    </Styled.DonutWrapper>
  );
}

export default view(Chart);



// WEBPACK FOOTER //
// ./src/components/finance/decisions/chart.js